// CHEMARA – Inhalte der Startseite und der Offertanfrage (Deutsch).
// Grundlage: freigegebene Unterlage „CHEMARA – Leistungen und Kundenanfragen“ (Nova, 2026-10-19) und Novas Vorgaben
// vom 2026-10-22 (helles Grau, viel Bild, eine Frage nach der anderen, Vorher-Nachher beim Scrollen).
// Keine Preise, keine Antwortfristen, keine Referenzen, keine technischen Zusagen.

// Bildmotive. Beispielbilder (frei lizenziert, siehe BILDQUELLEN.md), eigene Fotos und
// KI-Bilder (Blotato) – nie als eigene Referenzprojekte beschriftet. Dateien unter /public/assets/ (bilder-frei,
// eigene, ki). Ohne Datei zeigt die Seite einen Platzhalter mit der Motivbeschreibung.
export const BILDER = {
  hero_vorher: { motiv: "Garagenboden vorher: alter Beton mit abblätternder Farbe, Ölflecken, Risse", datei: null },
  hero_nachher: { motiv: "Heller Raum mit glänzendem Epoxid-/PU-Boden in Grau mit violetter Marmorierung", datei: "/assets/eigene/titel-epoxy-pu.webp" },
  boden_neu: { motiv: "Neuer, roher Betonboden, unbeschichtet", datei: "/assets/eigene/boden-neu.webp" },
  boden_beschichtet: { motiv: "Alter lackierter Boden, abgenutzt, abblätternd, Kratzer", datei: "/assets/eigene/lackboden-alt.webp" },
  boden_anderes: { motiv: "Anderer Untergrund, z. B. Fliesen oder Estrich", datei: null },
  lage_innen: { motiv: "Innenraum mit beschichtetem Boden", datei: "/assets/bilder-frei/innen-hell.webp" },
  lage_aussen: { motiv: "Aussenfläche, z. B. Terrasse oder Zufahrt", datei: "/assets/bilder-frei/aussen-terrasse.webp" },
  nutzung_garage: { motiv: "Garage mit Auto", datei: "/assets/bilder-frei/garage-glanz.webp" },
  nutzung_wohnraum: { motiv: "Wohnraum mit fugenloser Bodenfläche", datei: "/assets/ki/titel-marmor-epoxid.webp", hinweis: "KI-Bild" },
  nutzung_keller: { motiv: "Kellerraum", datei: "/assets/bilder-frei/keller.webp" },
  nutzung_werkstatt: { motiv: "Werkstatt mit Werkbank", datei: "/assets/bilder-frei/werkstatt.webp" },
  nutzung_gewerbe: { motiv: "Gewerbefläche, z. B. Laden oder Lager", datei: "/assets/bilder-frei/halle-glanz2.webp" },
  gestaltung_effekt: { motiv: "Design-Epoxidharz mit Effekt (Marmor-/Metallic-Optik)", datei: "/assets/ki/titel-marmor-epoxid.webp", hinweis: "KI-Bild" },
  gestaltung_flakes: { motiv: "Nahaufnahme Flakes-Beschichtung", datei: "/assets/eigene/flakes.webp" },
  gestaltung_versiegelung: { motiv: "Versiegelter Boden", datei: "/assets/eigene/versiegelung.webp" },
  gestaltung_einfarbig: { motiv: "Einfarbig beschichteter Boden", datei: "/assets/bilder-frei/innen-hell.webp" },
  oberflaeche_rutschhemmend: { motiv: "Rutschhemmende, leicht strukturierte Oberfläche, Nahaufnahme", datei: "/assets/zeichnung/profil-rutschhemmend.svg", hinweis: "Schema" },
  aussehen_matt: { motiv: "Glatter, matter Boden ohne Spiegelung", datei: "/assets/eigene/matt.webp" },
  aussehen_glaenzend: { motiv: "Glatter, glänzender Boden mit Spiegelung", datei: "/assets/eigene/glaenzend.webp" },
  leistung_ep: { motiv: "Wohnraum mit Hochglanz-Epoxidboden in Marmor-Optik", datei: "/assets/ki/titel-marmor-epoxid.webp" },
  fragezeichen: { motiv: "", datei: "/assets/eigene/fragezeichen.webp" },
  leistung_flakes: { motiv: "Flakes-Beschichtung", datei: "/assets/eigene/flakes.webp" },
  leistung_markierung: { motiv: "Bodenmarkierung", datei: "/assets/eigene/bodenmarkierung.webp" },
  leistung_versiegelung: { motiv: "Versiegelung", datei: "/assets/eigene/versiegelung.webp" },
  leistung_rutsch: { motiv: "Rutschhemmende Beschichtung", datei: "/assets/eigene/rutschhemmend.webp" },
  leistung_schleifen: { motiv: "Schleifen und Untergrundvorbereitung", datei: "/assets/eigene/schleifen.webp" },
};

export const START = {
  hero: {
    vorher: "Vorher",
    nachher: "Nachher",
    titel: "Bodenbeschichtungen",
    titel_zusatz: "in der ganzen Deutschschweiz",
    text: "Epoxidharz, Polyurethan, Flakes, Versiegelungen, Bodenmarkierungen und rutschhemmende Beschichtungen – inklusive Schleifen und Untergrundvorbereitung.",
    cta: "Offerte anfragen",
    scroll: "Scrollen und sehen, was aus einem Boden werden kann",
    hinweis_illustration: "KI-Bild",
  },
  leistungen: {
    label: "Leistungen",
    titel: "Was wir für Ihren Boden machen",
    items: [
      { id: "ep", titel: "Epoxidharz- und Polyurethanbeschichtungen", bild: "leistung_ep" },
      { id: "flakes", titel: "Flakes-Beschichtungen", bild: "leistung_flakes" },
      { id: "markierung", titel: "Bodenmarkierungen", bild: "leistung_markierung" },
      { id: "versiegelung", titel: "Versiegelungen", bild: "leistung_versiegelung" },
      { id: "rutsch", titel: "Rutschhemmende Beschichtungen", bild: "leistung_rutsch" },
      { id: "schleifen", titel: "Schleifen und Untergrundvorbereitung", bild: "leistung_schleifen" },
    ],
    hinweis: "Welcher Aufbau passt, hängt vom Untergrund, der Nutzung und der gewünschten Gestaltung ab.",
  },
  fuer: {
    titel: "Für Privatkunden, Unternehmen und öffentliche Auftraggeber",
    gebiet: "In der ganzen Deutschschweiz.",
  },
  ablauf: {
    label: "So einfach geht's",
    titel: "In wenigen Klicks zur Offertanfrage",
    schritte: [
      { titel: "Fragen antippen", text: "Ein paar kurze Fragen mit Bildern. „Weiss ich noch nicht“ geht immer." },
      { titel: "Fotos, wenn Sie möchten", text: "Fotos des Bodens helfen bei der ersten Einschätzung. Keine Registrierung." },
      { titel: "Wir klären den Rest", text: "Fehlende Angaben klären wir mit Ihnen." },
    ],
    unverbindlich: "Die Anfrage ist unverbindlich. Ihre genaue Offerte erhalten Sie, sobald wir Ihren Boden kennen.",
  },
  kontakt: {
    label: "Kontakt",
    email: "info@chemara.ch",
    telefon: "+41 76 379 31 35",
    telefon_link: "+41763793135",
    adresse: "Chemara GmbH\nRoggenfarstrasse 4\n8193 Eglisau",
  },
};

const WEISS_NICHT = { wert: "unentschieden", text: "Weiss ich noch nicht", fragezeichen: true };

// Klickstrecke: eine Frage pro Bildschirm. „wahl“ = antippen und automatisch weiter.
export const STRECKE = [
  {
    id: "boden", art: "wahl", frage: "Was für ein Boden ist heute da?",
    optionen: [
      { wert: "neu", text: "Neuer, noch unbeschichteter Boden", bild: "boden_neu" },
      { wert: "beschichtet", text: "Bereits lackiert oder beschichtet", bild: "boden_beschichtet" },
      { wert: "anderes", text: "Anderer Untergrund / weiss ich nicht", fragezeichen: true },
    ],
  },
  {
    id: "lage", art: "wahl", frage: "Wo liegt der Boden?",
    optionen: [
      { wert: "innen", text: "Innen", bild: "lage_innen" },
      { wert: "aussen", text: "Aussen", bild: "lage_aussen" },
    ],
  },
  {
    id: "nutzung", art: "wahl", frage: "Wofür wird der Raum genutzt?",
    optionen: [
      { wert: "garage", text: "Garage", bild: "nutzung_garage" },
      { wert: "wohnraum", text: "Wohnraum", bild: "nutzung_wohnraum" },
      { wert: "keller", text: "Keller", bild: "nutzung_keller" },
      { wert: "werkstatt", text: "Werkstatt", bild: "nutzung_werkstatt" },
      { wert: "gewerbe", text: "Gewerbe", bild: "nutzung_gewerbe" },
      { wert: "anderes", text: "Etwas anderes", fragezeichen: true },
    ],
  },
  {
    id: "gestaltung", art: "wahl", frage: "Wie soll der Boden aussehen?",
    optionen: [
      { wert: "effekt", text: "Design-Epoxidharz / Effekt", bild: "gestaltung_effekt" },
      { wert: "flakes", text: "Flakes", bild: "gestaltung_flakes" },
      { wert: "einfarbig", text: "Einfarbig", bild: "gestaltung_einfarbig" },
      { wert: "versiegelung", text: "Versiegelung", bild: "gestaltung_versiegelung" },
      WEISS_NICHT,
    ],
  },
  {
    // Eine Frage statt zwei: jede Antwort setzt Oberfläche und Aussehen (Felder der E-Mail bleiben gleich)
    id: "oberflaeche_wahl", art: "wahl", frage: "Welche Oberfläche?",
    optionen: [
      { wert: "glatt-matt", text: "Glatt und matt", bild: "aussehen_matt", oberflaeche: "glatt", aussehen: "matt" },
      { wert: "glatt-glaenzend", text: "Glatt und glänzend", bild: "aussehen_glaenzend", oberflaeche: "glatt", aussehen: "glaenzend" },
      { wert: "rutschhemmend", text: "Rutschhemmend", bild: "oberflaeche_rutschhemmend", oberflaeche: "rutschhemmend", aussehen: "unentschieden" },
      { wert: "beratung", text: "Weiss ich noch nicht", fragezeichen: true, oberflaeche: "beratung", aussehen: "unentschieden" },
    ],
  },
  {
    id: "flaeche", art: "wahl", frage: "Wie gross ist die Fläche ungefähr?",
    optionen: [
      { wert: "bis20", text: "bis 20 m²", gross: "≤ 20" },
      { wert: "20-50", text: "20 – 50 m²", gross: "20–50" },
      { wert: "50-100", text: "50 – 100 m²", gross: "50–100" },
      { wert: "100-250", text: "100 – 250 m²", gross: "100–250" },
      { wert: "ueber250", text: "über 250 m²", gross: "> 250" },
      { wert: "unbekannt", text: "Noch nicht bekannt", fragezeichen: true },
    ],
  },
  { id: "standort", art: "standort", frage: "Wo befindet sich der Boden?", unter: "Die Postleitzahl genügt." },
  { id: "kontakt", art: "kontakt", frage: "Wie erreichen wir Sie?", unter: "Nur die E-Mail-Adresse ist nötig." },
];

export const TEXTE = {
  seiten_titel: "Offertanfrage",
  seite_intro_titel: "Ihr neuer Boden in wenigen Schritten",
  seite_intro:
    "Tippen Sie einfach an, was passt. Am Schluss sehen Sie alles noch einmal. Die Anfrage ist unverbindlich.",
  zurueck: "Zurück",
  weiter: "Weiter",
  wunsch_hinweis:
    "Ihre Auswahl beschreibt Ihre Wünsche – keine Zusage, dass jede Kombination technisch möglich ist. Das klären wir mit Ihnen.",
  plz: "Postleitzahl",
  ort: "Ort (freiwillig)",
  plz_hinweis: "Bitte die vierstellige Postleitzahl eingeben.",
  email: "E-Mail",
  telefon: "Telefon (freiwillig)",
  name: "Name (freiwillig)",
  info: "Möchten Sie noch etwas ergänzen? (freiwillig)",
  info_ph: "z. B. Zustand des Bodens, Schäden, gewünschte Farbe, Zeitraum",
  fotos: "Fotos Ihres Bodens (freiwillig)",
  fotos_knopf: "Foto hinzufügen",
  fotos_hinweis: "Bis 6 Fotos. Sie werden vor dem Senden verkleinert.",
  zusammenfassung: "Passt alles?",
  zusammenfassung_text: "Mit „Ändern“ springen Sie direkt zur Frage zurück.",
  aendern: "Ändern",
  senden: "Unverbindliche Offerte anfragen",
  sendet: "Wird gesendet …",
  erfolg_titel: "Danke für Ihre Anfrage",
  erfolg_text:
    "Ihre Anfrage ist bei uns eingegangen. Sie ist unverbindlich; eine verbindliche Offerte folgt erst nach Klärung von Untergrund, Nutzung und Aufbau.",
  erfolg_test: "Testmodus: Die Anfrage wurde nicht gesendet, sondern nur lokal abgelegt.",
  fehler: "Senden fehlgeschlagen. Bitte später nochmals versuchen oder direkt an info@chemara.ch schreiben.",
  fehler_eingabe: "Bitte prüfen Sie Ihre Angaben.",
  datenschutz: "Ihre Angaben gehen per E-Mail an info@chemara.ch und werden nicht in einer Datenbank gespeichert.",
  datenschutz_link: "Datenschutz",
};
